import { render, staticRenderFns } from "./DisplayResults.vue?vue&type=template&id=4b2332b1&"
import script from "./DisplayResults.vue?vue&type=script&lang=js&"
export * from "./DisplayResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports